{
  "version": 1,
  "asset_id": "e91add5e-4251-490f-853d-637ebfe719bb",
  "project_id": "323b9e15-9042-4162-b531-66ca33513bd6",
  "url": "/__l5e/assets-v1/e91add5e-4251-490f-853d-637ebfe719bb/mrdrive-drives.png",
  "r2_key": "a/v1/323b9e15-9042-4162-b531-66ca33513bd6/e91add5e-4251-490f-853d-637ebfe719bb/mrdrive-drives.png",
  "original_filename": "mrdrive-drives.png",
  "size": 2872369,
  "content_type": "image/png",
  "created_at": "2026-07-17T00:25:19Z"
}
